import { render, staticRenderFns } from "./CopilotAuditList.vue?vue&type=template&id=384d626d&scoped=true"
import script from "./CopilotAuditList.vue?vue&type=script&lang=js"
export * from "./CopilotAuditList.vue?vue&type=script&lang=js"
import style0 from "./CopilotAuditList.vue?vue&type=style&index=0&id=384d626d&prod&lang=scss&scoped=true"
import style1 from "./CopilotAuditList.vue?vue&type=style&index=1&id=384d626d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d626d",
  null
  
)

export default component.exports